export const formValidator = (validationFields: any, data: any) => {
  switch (data.key) {
    case 'name':
      validationFields.name = !!data.value
      break
  }

  return validationFields
}
